import Swiper from "swiper"

export default class Packages {

  constructor(el) {
    this.el = el
    this.slider = null
  }

  init () {
    this.initSlider()
  }

  initSlider () {

    if (this.slider) return

    this.slider = new Swiper(this.el, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      watchOverflow: true,
      observer: true,
      breakpoints: {
        768: {
          slidesPerView: 'auto',
          spaceBetween: 20,
        },
        1025: {
          slidesPerView: 4,
          spaceBetween: 20,
        }
      }
    })

  }

}